import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createDeliverySectionController } from '@wix/delivery-section/controller';
import { deliverySectionParamsMapper, cartV2ToDeliverySectionParams } from '../utils/mappers';
import { BIService } from '../services/BIService';
export class DeliverySectionCheckoutController {
  constructor(controllerParams) {
    var _this = this;
    _defineProperty(this, "deliverySectionController", void 0);
    _defineProperty(this, "getCheckoutV1", void 0);
    _defineProperty(this, "onRefreshCheckout", void 0);
    _defineProperty(this, "getCartV2", void 0);
    _defineProperty(this, "biService", void 0);
    _defineProperty(this, "getBiData", async () => {
      if (this.getCartV2) {
        const cart = await this.getCartV2();
        return {
          purchaseFlowId: cart.purchaseFlowId,
          checkoutId: cart._id,
          cartId: cart._id
        };
      } else {
        const checkout = await this.getCheckoutV1();
        return {
          purchaseFlowId: checkout.purchaseFlowId,
          checkoutId: checkout._id,
          cartId: checkout.cartId
        };
      }
    });
    _defineProperty(this, "getDeliverySectionParams", async () => {
      return {
        ...(this.getCartV2 ? cartV2ToDeliverySectionParams(await this.getCartV2()) : deliverySectionParamsMapper(await this.getCheckoutV1())),
        onRefreshCheckout: this.onRefreshCheckout
      };
    });
    _defineProperty(this, "onDataPresented", async function () {
      const {
        deliveryOptions,
        hasPartialShippingOptions
      } = arguments.length <= 0 ? undefined : arguments[0];
      const {
        purchaseFlowId,
        checkoutId,
        cartId
      } = await _this.getBiData();
      await _this.biService.shippingOptionsPresentedInCheckout(purchaseFlowId, checkoutId, cartId, deliveryOptions, hasPartialShippingOptions);
    });
    _defineProperty(this, "onDeliveryMethodSelected", async function () {
      const {
        deliveryOptions,
        selectedDeliveryOption,
        hasPartialShippingOptions
      } = arguments.length <= 0 ? undefined : arguments[0];
      const shippingOptionIndex = deliveryOptions == null ? void 0 : deliveryOptions.findIndex(group => {
        var _group$options;
        return (_group$options = group.options) == null ? void 0 : _group$options.some(option => option.id === selectedDeliveryOption);
      });
      const {
        purchaseFlowId,
        checkoutId,
        cartId
      } = await _this.getBiData();
      await _this.biService.shippingOptionSelected(purchaseFlowId, checkoutId, cartId, deliveryOptions, selectedDeliveryOption, hasPartialShippingOptions, shippingOptionIndex >= 0 ? shippingOptionIndex : undefined);
    });
    const {
      flowAPI,
      controllerConfig,
      getCheckoutV1,
      getCartV2,
      onStateChanged,
      setDeliveryMethodId,
      onRefreshCheckout
    } = controllerParams;
    this.getCheckoutV1 = getCheckoutV1;
    this.getCartV2 = getCartV2;
    this.onRefreshCheckout = onRefreshCheckout;
    this.biService = new BIService(controllerConfig);
    this.deliverySectionController = createDeliverySectionController({
      flowAPI,
      controllerConfig,
      getDeliverySectionParams: this.getDeliverySectionParams,
      setDeliveryMethodId,
      onStateChanged,
      biLogger: {
        onDataPresented: this.onDataPresented,
        onDeliveryMethodSelected: this.onDeliveryMethodSelected
      }
    });
  }
  async init() {
    await this.deliverySectionController.init();
  }
  async onCheckoutUpdated() {
    await this.deliverySectionController.onDataChanged();
  }
}
//# sourceMappingURL=DeliverySectionCheckoutController.js.map